import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom';
import './ProductCard.scss'
import request from '../../request'
import { useTranslation } from 'react-i18next';
import favoriteactive from "../../assets/images/card/favorite.svg";
import favoriteinactive from "../../assets/images/card/BlackFavourite.svg";
import snowImg from "../../assets/images/snow-img.svg";
import quotationImg from "../../assets/images/Quotation.png";
import chilledImg from "../../assets/images/Chilled.svg";
import ADDCART from "../../assets/images/card/ADDCART.svg"
import axios from 'axios';
import { useStateValue } from '../../store/state';
import moment from 'moment';
import { toast } from 'react-toastify';
import { browserName, browserVersion } from 'react-device-detect';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import PDPImageCarousel from '../PDPPage/ProductInfo/PDPImageCarousel/PDPImageCarousel';
import ProductDefaultImage_transparent from "../../assets/images/card/ProductDefaultImage_transparent.png";
import NoAddressModal from '../NoAddressModal/NoAddressModal';

function ProductCard(props) {
  const { image, pack_size, name, sku, selling_unit_price, entity_id, selling_unit, quote, favourite, options, is_in_stock, url_key, order_taking, storage, moq } = props.data
  const { setRefreshAPI, title, refreshAPI, devicetype, category_id, onUnfavourite } = props
  const { CDN_BASE_URL_FLAG, imageendpoint } = request
  const [currentID, setCurrentID] = useState(0)
  const preloadedImageRef = useRef(null);
  const { t } = useTranslation();
  const [{ cart, CATALOG_COUNTRY_FILTER_DATA }, dispatch] = useStateValue();
  const location = useLocation();
  const isPDPPage = location.pathname.startsWith("/pdp/");
  const [favourites, setFavourites] = useState(favourite);
  const fullImageUrl = `${imageendpoint}media/catalog/product${image}`;
  const history = useHistory();
  const pendingCartItem = localStorage.getItem("pendingAddToCart");
  const pendingFavItem = localStorage.getItem("pendingAddToFavorite");
  const token = localStorage.getItem("token");
  const hasRun = useRef(false);
  const [showNoAddressModal, setShowNoAddressModal] = useState(false);

  // Before login after login add to cart logic here
  useEffect(() => {
    if (hasRun.current) return; // Prevent running again
    if (token && pendingCartItem) {
      const { entity_id: pendingID } = JSON.parse(pendingCartItem);
      if (pendingID === entity_id) {       // Only add if this product card matches the pending product
        hasRun.current = true; // Mark as done
        addtocart(); // Your existing addtocart function    
        localStorage.removeItem("pendingAddToCart");
        history.push("/cart");
      }
    }
  }, [pendingCartItem]);

  // Before login after login add to fav logic here
  useEffect(() => {
    if (hasRun.current) return; // Prevent running again
    if (token && pendingFavItem) {
      const { entity_id: pendingID } = JSON.parse(pendingFavItem);
      if (pendingID === entity_id) {        // Only add if this product card matches the pending product
        hasRun.current = true; // Mark as done
        addToFav(); // Your existing addToFav function
        localStorage.removeItem("pendingAddToFavorite");
        history.push("/myfavourite");
      }
    }
  }, [pendingFavItem]);

  useEffect(() => {
    if (image === undefined) return;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = `${request.image}media/catalog/product${image}`;
    link.as = 'image';

    // Append the link element to the head
    document.head.appendChild(link);

    // Update the src of the preloadedImageRef once the resource is loaded
    link.onload = () => {
      preloadedImageRef.current.style.display = 'block';
      preloadedImageRef.current.src = link.href;
    };
  }, [image]);

  function formatToCurrency(price) {
    return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const getCountryFlagUrl = () => {
    if (props.data.country_of_manufacture) {
      return `${CDN_BASE_URL_FLAG}${props.data.country_of_manufacture.toLowerCase()}.svg`;
    }
    return null;
  };
  const replacements = {
    "KG": t('KG'),
    "PC": t('PC'),
    "PK": t('PK'),
    "BG": t("BG"),
    "BK": t("BK"),
    "BT": t("BT"),
    "BX": t("BX"),
    "CA": t("CA"),
    "CP": t("CP"),
    "CT": t("CT"),
    "DR": t("DR"),
    "DZ": t("DZ"),
    "GL": t("GL"),
    "GM": t("GM"),
    "JR": t("JR"),
    "LT": t("LT"),
    "ML": t("ML"),
    "OZ": t("OZ"),
    "PA": t("PA"),
    "SC": t("SC"),
    "SH": t("SH"),
    "TI": t("TI"),
    "TR": t("TR"),
    "TU": t("TU"),
    "TY": t("TY"),
  };

  const updatedData = (item) => {
    // Check if item is defined and is a string
    if (!item || typeof item !== 'string') {
      return item; // Return the item as is if it's not a valid string
    }

    let updatedItem = item;
    Object.keys(replacements).forEach(key => {
      updatedItem = updatedItem.replace(key, replacements[key]);
    });

    return updatedItem;
  };

  function formatToCurrency(price) {
    return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // Function to format pack size based on storeid
  function formatPackSize(packSize) {
    // If storeid is 1, display the pack size in English
    if (localStorage.getItem("storeid") === 1) {
      return packSize; // Return as is for English display
    } else {
      // Otherwise, format for Thai
      if (typeof packSize !== 'string') return packSize;
      if (packSize.startsWith('.')) packSize = '0' + packSize;
      return updatedData(packSize); // Replace units with localized ones
    }
  }

  // ... existing code ...
  const createlog = async () => {
    try {
      const res = await axios.get("https://geolocation-db.com/json/");
      await axios({
        method: "post",
        url: request.newlog,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: {
          data: {
            customer_id: localStorage.getItem("userid"),
            company_id: localStorage.getItem("companyid"),
            remote_ip: res.data.IPv4,
            user_agent: `${browserName} Version:${browserVersion}`,
            action: `${JSON.parse(localStorage.getItem("userdata")).firstname
              } added 1 ${name} in the cart`,
            action_type: "save",
            functioncall_url: "user/save/",
          },
        },
      });
    } catch (e) {
      console.log(e)
    }
  };
  const flyToCart = (startElement, endElement) => {
    if (!startElement || !endElement) return;

    const startRect = startElement.getBoundingClientRect();
    const endRect = endElement.getBoundingClientRect();

    const flyingItem = document.createElement('div');
    flyingItem.className = 'flying-item';

    Object.assign(flyingItem.style, {
      position: 'fixed',
      left: `${startRect.left}px`,
      top: `${startRect.top}px`,
      width: '36px',
      height: '36px',
      backgroundImage: `url(${ADDCART})`,
      backgroundSize: 'contain',
      zIndex: '9999',
      transition: 'all 2s cubic-bezier(0.4, 0, 0.2, 1)',
      pointerEvents: 'none',
      backgroundColor: 'white',
      borderRadius: '50%',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
    });

    document.body.appendChild(flyingItem);

    requestAnimationFrame(() => {
      flyingItem.style.transition = 'all 0.6s cubic-bezier(0.2, 0.6, 0.4, 1)';
      flyingItem.style.transform = `translate(${endRect.left - startRect.left}px, ${endRect.top - startRect.top}px) scale(0.5)`;
      flyingItem.style.opacity = '0';
    });

    flyingItem.addEventListener('transitionend', () => {
      flyingItem.remove();
      const cartIcon = document.getElementById('cart-icon');
      if (cartIcon) cartIcon.classList.add('animate');
    });
  };
  // Add to cart (single product)
  const addtocart = async () => {
    if (is_in_stock == "0") return;

    const productElement = document.getElementById(`data-product-id-${entity_id}`);
    const cartIcon = document.getElementById('cart-icon');
    let addressdata = []
    try {
      if (productElement) {
        productElement.classList.add('loading');
        productElement.style.pointerEvents = 'none';
      }
      if (productElement && cartIcon) {
        flyToCart(productElement, cartIcon);
      }
      const address = await axios({
        method: "get",
        url: `${request.getbranch}/${localStorage.getItem("userid")}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      // For social login user her check delivery address there or not, if not user need to add deliveryaddress
      if (address?.data?.length === 0) {
        setShowNoAddressModal(true);
        return;
      }

      addressdata.push(address.data);
    } catch (e) {
      console.log(e)
      // toast.error(e.response?.data?.message);
    }
    let defaultaddress;
    addressdata[0]?.find((data) => {
      if (data?.chk_default == "Y") {
        defaultaddress = data;
      }
    });
    const findsku = cart.find((c) => c.sku === sku);

    let date;
    try {
      const datechk = await axios({
        method: "get",
        url: `${request.erprequest}/products/${sku}/delivery-date`,
        headers: {
          token: `Bearer ${localStorage.getItem("erpToken")}`,
        },
      });
      date = datechk.data.data[0].DELIVER_DATE.slice(parseInt(defaultaddress?.leadtime_days));
    } catch (e) {
      console.log(e);
    }
    if (date) {
      try {
        const cartdata = await axios({
          method: "post",
          url: request.cartadd,
          data: {
            cartItem: {
              sku: sku,
              quote_id: localStorage.getItem("cartid"),
              qty: moq ? parseInt(moq) : 1,
              price: options[0]?.price,
              extension_attributes: {
                unit: options[0]?.order_type,
              },
            },
            splitorder: {
              company_id: localStorage.getItem("companyid"),
              customer_id: localStorage.getItem("userid"),
              branch_id: defaultaddress?.address_id,
              product_id: entity_id,
              item_id: findsku?.item_id ? findsku?.item_id : 0,
              name: name,
              sku: sku,
              delivery_date: moment(date[0]?.DD).format("YYYY-MM-DD"),
            },
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (cartdata.data[0].errors == false) {
          toast.info("The Requested qty is not available");
        }
        if (cartdata.data[0].success) {
          createlog();
        }
        dispatch({
          type: "CART_STATUS",
        });
      } catch (e) {
        console.log(e)
      }
    }
  };

  // FAVOURITES HANDLER
  const addToFavHandler = () => {
    setFavourites(prev => !prev);
    if (favourite) {
      deletefromFav();
      // Remove from the list in parent
      onUnfavourite?.(entity_id);
    } else {
      addToFav();
    }
    setRefreshAPI(!refreshAPI)
  };

  // _ADD TO FAVOURITES API
  const addToFav = async () => {
    try {
      await axios({
        method: "post",
        url: request.addFav,
        data: {
          data: {
            customer_id: localStorage.getItem("userid"),
            product_id: entity_id,
            company_id: localStorage.getItem("companyid"),
          },
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      dispatch({
        type: "GENERAL__TRIGGER",
      });
      toast.success(`${name} ${t("FAVADDED")}`);
    } catch (e) {
      console.log(e);
    }
  };

  // DELETE FROM FAVOURITES API
  const deletefromFav = async () => {
    try {
      await axios({
        method: "delete",
        url: `${request.deletefav}/${entity_id}/${localStorage.getItem("userid")}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      dispatch({
        type: "GENERAL__TRIGGER",
      });
      toast.success(`${name} ${t("FAVREMOVED")}`);
    } catch (e) {
      console.log(e);
    }
  };

  const isFrozen = () => {
    return (storage || '').startsWith('FROZEN')
  }

  const isChilled = () => {
    return (storage || '').startsWith('CHILLED')
  }

  // truncateName namr for mobile and web
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 912);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 912);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const truncateName = (name) => {
    const maxLength = isMobile ? 50 : 60;
    return name.length > maxLength ? `${name.slice(0, maxLength)}...` : name;
  };


  return (
    <div
      className={`PRODUCTCARD ${currentID === entity_id && "HOVERED__CARD"}`}
      onMouseEnter={() => setCurrentID(entity_id)}
      onMouseLeave={() => setCurrentID(0)}
    >
      {currentID === entity_id &&
        <img className='HOVERED__CARD__FAV'
          src={favourites ? favoriteactive : favoriteinactive}
          onClick={() => {
            const token = localStorage.getItem("token");
            if (!token) {
              localStorage.setItem("pendingAddToFavorite", JSON.stringify({ entity_id }));
              localStorage.setItem("redirectAfterLogin", window.location.pathname);
              history.replace("/login", { from: location.pathname });
            } else {
              addToFavHandler();
            }
          }}

          alt=""
        />
      }
      {order_taking == "Y" && currentID === entity_id ?
        <Link
          className='ORDERTAKING__CALENDAR HOVERED__CARD__ADDCART'
          to={{
            pathname: `/pdp/${!quote ? "catalog" : "product"}/${order_taking == "Y" ? "ordertaking" : "stock"}/${category_id}/${entity_id}/${url_key}`,
            state: { fullImageUrl }
          }}
          onClick={localStorage.setItem("redirectAfterLogin", window.location.pathname)}
          state={{ fullImageUrl }}
        >

          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" >
            <g clip-path="url(#clip0_1972_38528)">
              <rect width="28" height="28" rx="14" fill="#37BFA7" />
              <path d="M10.1111 13.2H11.6667V14.8H10.1111V13.2ZM21 9.2V20.4C21 21.28 20.3 22 19.4444 22H8.55556C7.69222 22 7 21.28 7 20.4L7.00778 9.2C7.00778 8.32 7.69222 7.6 8.55556 7.6H9.33333V6H10.8889V7.6H17.1111V6H18.6667V7.6H19.4444C20.3 7.6 21 8.32 21 9.2ZM8.55556 10.8H19.4444V9.2H8.55556V10.8ZM19.4444 20.4V12.4H8.55556V20.4H19.4444ZM16.3333 14.8H17.8889V13.2H16.3333V14.8ZM13.2222 14.8H14.7778V13.2H13.2222V14.8Z" fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_1972_38528">
                <rect width="28" height="28" rx="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Link>
        : currentID === entity_id && <img
          onClick={() => {
            const token = localStorage.getItem("token");
            if (!token) {
              // Save the product info to add after login
              localStorage.setItem("pendingAddToCart", JSON.stringify({ entity_id }));
              localStorage.setItem("redirectAfterLogin", window.location.pathname);
              history.replace("/login", { from: location.pathname });
            } else {
              addtocart(); // Already logged in, add to cart directly
            }
          }}
          id={`data-product-id-${entity_id}`}
          className={`HOVERED__CARD__ADDCART ${is_in_stock == "0" && "CART__NOSTOCK"}`}
          src={ADDCART}
          alt="Add to cart"
          style={{
            position: "absolute",
            bottom: 10,
            right: 10,
            width: 36,
            height: 36,
            cursor: "pointer",
            background: "#fff",
            borderRadius: "50%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)"

          }}

        />
      }

      {devicetype === "mobile" ?
        <>
          <Link to={`/pdp/${!quote ? "catalog" : "product"}/${order_taking === "Y" ? "ordertaking" : "stock"}/${category_id}/${entity_id}/${url_key}`}
            onClick={localStorage.setItem("redirectAfterLogin", window.location.pathname)}
          >
            <img ref={preloadedImageRef}
              id="preloadedImage"
              src={`${request.image}media/catalog/product${image}`}
              alt=""
              height="100%"
              width="100%"
              className='PC__IMAGE'
              onError={(e) => {
                e.target.onerror = null; // Prevent infinite loop in case fallback also fails
                e.target.src = ProductDefaultImage_transparent; // Set your fallback image path here
              }}
            />
          </Link>
          <div className='product_btn_wrapper' style={{ visibility: (order_taking === "Y" || isFrozen() || isChilled() || props.data.country_of_manufacture) ? 'visible' : 'hidden' }}>
            {order_taking === "Y" && <span className='CARD__PREORDER'>Pre-Order</span>}
            {isFrozen() && <img src={snowImg} className="snow-img" alt="Frozen" />}
            {isChilled() && <img src={chilledImg} className="snow-img" alt="Chilled" />}
            {props.data.country_of_manufacture && (
              <div className="country-info">
                <img
                  src={getCountryFlagUrl()}
                  className="country-flag"
                  alt={props.data.country_of_manufacture}
                />
                <span className="country-name">{props.data.country_of_manufacture}</span>
              </div>
            )}
          </div>
        </> :
        <div>
          <Link
            to={{ pathname: `/pdp/${!quote ? "catalog" : "product"}/${order_taking == "Y" ? "ordertaking" : "stock"}/${category_id}/${entity_id}/${url_key}`, state: { fullImageUrl } }}
            prefetch
            onClick={localStorage.setItem("redirectAfterLogin", window.location.pathname)}
          >
            <img src={`${request.image}media/catalog/product${image}`} alt=""
              ref={preloadedImageRef}
              id="preloadedImage"
              height="100%"
              width="100%"
              className='PC__IMAGE'
              onError={(e) => {
                e.target.onerror = null; // Prevent infinite loop in case fallback also fails
                e.target.src = ProductDefaultImage_transparent // Set your fallback image path here
              }}
            />


          </Link>
          <div className='product_btn_wrapper' style={{ visibility: (order_taking === "Y" || isFrozen() || isChilled() || props.data.country_of_manufacture) ? 'visible' : 'hidden' }}>
            {order_taking === "Y" && <span className='CARD__PREORDER'>Pre-Order</span>}
            {isFrozen() && <img src={snowImg} className="snow-img" alt="Frozen" />}
            {isChilled() && <img src={chilledImg} className="snow-img" alt="Chilled" />}
            {props.data.country_of_manufacture && (
              <div className="country-info">
                <img
                  src={getCountryFlagUrl()}
                  className="country-flag"
                  alt={props.data.country_of_manufacture}
                />
                <span className="country-name">{props.data.country_of_manufacture}</span>
              </div>
            )}
          </div>
        </div>

      }
      <div className={`PC__CONTENT ${quote ? "QUOTE__PRODUCT" : "CATALOG__PRODUCT"}`}>
        {/* <h5 className='PC__NAME' title={name}>{name}</h5> */}
        <div className='PC__NAME' title={name}>
          {t(truncateName(name))}
        </div>
        <div className='PC__SKU'>{sku}</div>
        <div className='PC__PACKSIZE'>
          {t("SIZE")} {formatPackSize(pack_size)}
        </div>
        <div className='PC__QUOTATION__PRICE' >
          {quote && <img src={quotationImg} alt="" className='QUOTES' />}
          <div className='PC__PRICE'><span className='symbol'>฿</span> {formatToCurrency(parseFloat(selling_unit_price).toFixed(2))}/<span className='PC__UNIT'>{t(updatedData(selling_unit))}</span></div>
        </div>

        {isPDPPage && (
          <PDPImageCarousel
            fullImageUrl={fullImageUrl}
            images={props.data.images}
          />
        )}
      </div>


      {/* Add this at the end */}
      <NoAddressModal
        open={showNoAddressModal}
        onClose={() => setShowNoAddressModal(false)}
        t={t}
      />

    </div>
  )
}

export default ProductCard